export class HisProblemCaseSharedModuleOptions {
    public static readonly RIGHT_CREATE_PROBLEM_CASE = [
        'RIGHT_CS_PSV_PROBLEM_CASE_PROCESSING_CREATE_PROBLEM_CASE',
    ];
}
